import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { chatFeatureKey } from '../key';

export type GetMessagesQueryFilter = {
  chatroomId: string;
};

const localKey = ['messages'] as const;

type MessagesListQueryType = GenericListQueryKey<GetMessagesQueryFilter>;

const getMessagesListQueryKey = (params: MessagesListQueryType) =>
  generateListQueryKey({
    prefix: [...chatFeatureKey, ...localKey],
  })(params);

export const getMessagesInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getMessagesListQueryKey,
});
